import { TabOption } from "../../../../shared/components/FormTabHeader"
import * as Yup from "yup"
export interface IBankTransaction {
    id: string
    date: string // LocalDate -> ISO string format (örn: "2025-09-25")
    iban: string
    bank: string
    branch: string
    bankAmount: number // BigDecimal -> number
    currency: string
    bankKurus: number // BigDecimal -> number
    recieptNo: string
    cashRegisterCode: string
    transactionBranch: string
    transactor: string
    description: string
}


export const initialBankTransactionValues: IBankTransaction = {
    id: '',
    date: "",               // YYYY-MM-DD formatında tarih string
    iban: "",
    bank: "",
    branch: "",
    bankAmount: 0,          // varsayılan 0
    currency: "",
    bankKurus: 0,           // varsayılan 0
    recieptNo: "",
    cashRegisterCode: "",
    transactionBranch: "",
    transactor: "",
    description: ""
}


export const BankTransactionValidationSchema = Yup.object().shape({
    date: Yup.string(), // LocalDate -> string olarak tutuluyor
    iban: Yup.string()
        .required("IBAN zorunludur")


})


export const tabOptions: TabOption<'form'>[] = [
    { key: 'form', title: 'Hesaba Para Yatırma', icon: 'bi bi-geo-alt' },

]
export const IBAN_OPTIONS = [
    { value: "TR00 0000 0000 0000 0000 0000 00", label: "ŞAHSİ HESAP -- TL" },
    { value: "TR11 1111 1111 1111 1111 1111 11", label: "ŞİRKET HESAP -- TL" },
]
export const BRANCH_OPTIONS = [
    { value: "MERKEZ", label: "MERKEZ" },
    { value: "SUBE1", label: "ŞUBE 1" },
    { value: "SUBE2", label: "ŞUBE 2" },
]
export const CASH_REGISTER_OPTIONS = [
    { value: "MERKEZ", label: "MERKEZ" },
    { value: "KASA1", label: "KASA 1" },
]